import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import Decline from "app/_pages/_healthSafetyEnvironment/IncidentManagement/DeclinePopup";
import {
  absentTraineeStatus,
  addTrainingToBatch,
  getAllTrainingBatches,
  removeTraineeStatue,
  updateAssignersStatus,
} from "app/_services/ehs/ehsTrainingServices";
import React, { useCallback, useEffect, useMemo, useState, Component } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { FaCheck, FaTimes, FaUserMinus } from "react-icons/fa";
import {
  trainingbatchFilterFields,
  TRAINING_STATUS,
  validateBatchRowFilter,
} from "../../CONSTANTS";
import toastr from "toastr";
import { confirmAlert } from "react-confirm-alert";
import {
  isUserMM,
  isUserSO,
  isUserVTO,
} from "app/_pages/_healthSafetyEnvironment/IncidentManagement/Helper";
import FormBtn from "app/Components/CommanComponents/FormBtn";
import FormSelect from "app/Components/_form/FormSelect/FormSelect";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { isBefore } from "date-fns";
import moment from "moment";
import { DDMMYYYYFormat, isSameOrAfter, YYYYMMDDFormat } from "app/_helpers/dateHelper";
import { useForm } from "app/_helpers/hooks";
import TrainingBatchFilters from "./TrainingBatchFilters";
import { getTrainingManagementStatusClass, TM_STATUS } from "../../CONSTANTS";

function TrainingBatchHistoryTab({
  trainings,
  batchesData,
  showFilter,
  setShowFilterBtn = () => {},
}) {
  const [batches, setBatches] = useState([]);
  const [initialBatches, setInitialBatches] = useState([]);
  const [tableList, setTableList] = useState([]);
  const [finalTableList, setFinalTableList] = useState([]);
  const [selectedBatchId, setSelectedBatchId] = useState(null);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [search, setSearch] = useState("");
  const [filterForm, onChangeFilter, setFilterForm] = useForm(
    {},
    trainingbatchFilterFields
  );
  //const [showFilter, setShowFilter] = useState(false);

  const onReset = () => setFilterForm({ batchName: "", centerName: "", centerCode: "" });

  useEffect(() => {
    setInitialBatches(batchesData);
  }, [batchesData]);

  useEffect(() => {
    setBatches(JSON.parse(JSON.stringify(initialBatches)));
    setFinalTableList(JSON.parse(JSON.stringify(initialBatches)));
  }, [initialBatches]);

  const onClickRow = useCallback(
    (row) => {
      setTableList([]);
      setShowFilterBtn(false);
      setSelectedBatchId(row?.id);
      setSearch("");
      setSelectedBatch(row);
    },
    [setShowFilterBtn]
  );

  const sortableColumn = useMemo(
    () =>
      selectedBatchId
        ? [
            {
              dataField: "sid",
              text: "S.No.",
              sort: true,
            },
            {
              dataField: "traineeTypeView",
              text: "Trainee Type",
              sort: true,
            },
            {
              dataField: "traineeName",
              text: "Trainee Name",
              sort: true,
            },
            {
              dataField: "trainingTypeView",
              text: "Training Type",
              sort: true,
            },
            {
              dataField: "ehsSite.name",
              text: "Location",
              sort: true,
            },
            // {
            //   dataField: "centerName",
            //   text: "Name of Centre",
            //   sort: true,
            // },
            // {
            //   dataField: "centerCode",
            //   text: "Centre Code",
            //   sort: true,
            // },
            // {
            //   dataField: "batchId",
            //   text: "Batch ID",
            //   sort: true,
            // },
            // {
            //   dataField: "duration",
            //   text: "Duration",
            //   sort: true,
            // },
            // {
            //   dataField: "minesArea",
            //   text: "Mines Area",
            //   sort: true,
            // },
            {
              dataField: "trainingCategoryName",
              text: "Skill Category",
              sort: true,
            },
            {
              dataField: "trainingSubCategoryName",
              text: "Skill Sub Category",
              sort: true,
            },
            {
              dataField: "trainingStatusView",
              text: "Status",
              sort: true,
              formatter: (status, row) => {
                return (
                  <div className={getTrainingManagementStatusClass(status)}>{status}</div>
                );
              },
            },
          ]
        : [
            {
              dataField: "sid",
              text: "S.No.",
              sort: true,
            },
            {
              dataField: "siteName",
              text: "Location",
              sort: true,
            },
            {
              dataField: "trainingTypeView",
              text: "Training Type",
              sort: true,
            },
            {
              dataField: "batchId",
              text: "Batch ID",
              sort: true,
              formatter: (cell, row, rowIndex) => {
                return (
                  <span
                    className="icons pointer text-cyanBlue"
                    onClick={() => onClickRow(row)}
                  >
                    {row.batchId}
                  </span>
                );
              },
            },
            {
              dataField: "centerName",
              text: "Centre",
              sort: true,
            },
            {
              dataField: "centerCode",
              text: "Centre Code",
              sort: true,
            },
            {
              dataField: "trainingCategoryName",
              text: "Skill Category",
              sort: true,
            },
            {
              dataField: "trainingDateView",
              text: "Training Start Date",
              sort: true,
              // formatter: (startDate) => {
              //   return DDMMYYYYFormat(startDate);
              // }
            },
            // {
            //   dataField: "areaName",
            //   text: "Area",
            //   sort: true,
            // },
            {
              dataField: "duration",
              text: "Duration",
              sort: true,
            },
            {
              dataField: "count",
              text: "Staff Count",
              sort: true,
            },
            {
              dataField: "batchStatusView",
              text: "Status",
              sort: true,
              formatter: (status, row) => {
                return (
                  <div className={getTrainingManagementStatusClass(status)}>{status}</div>
                );
              },
            },
          ],
    [onClickRow, selectedBatchId]
  );

  useEffect(() => {
    console.log("useEffect", selectedBatchId);
    setTableList(
      selectedBatchId
        ? batches.find((d) => d.id === selectedBatchId)?.traineeList || []
        : batches.filter((row) => {
            if (!search) return true;

            if (
              row.traineeList?.find((t) =>
                t.traineeName?.toLowerCase().includes(search.toLowerCase())
              )
            )
              return true;

            for (const key in row) {
              if (typeof row[key] !== "string" && typeof row[key] !== "number") continue;

              if (row[key].toString().toLowerCase().includes(search.toLowerCase()))
                return true;
            }

            return false;
          })
    );
  }, [batches, search, selectedBatchId]);

  useEffect(() => {
    let data = finalTableList?.filter((obj) => {
      return validateBatchRowFilter(obj, filterForm);
    });
    setBatches(data);
  }, [filterForm, finalTableList]);

  const resetBatch = () => {
    setSelectedBatchId(null);
    setSelectedBatch(null);
    setSearch("");
    setShowFilterBtn(true);
    setTableList([]);
  };

  const CustomSearch = useCallback(() => {
    return (
      <label htmlFor="search-bar-0" className="search-label">
        <span className="sr-only">Search this table</span>
        <input
          id="search-bar-0"
          type="text"
          aria-label="enter text you want to search"
          className="form-control mb-0"
          placeholder="Search"
          onChange={(e) => setSearch(e.target.value)}
        />
      </label>
    );
  }, []);

  console.log("TrainingBatchTab", selectedBatchId);

  console.log("initialBatches", initialBatches);
  console.log("batches", batches);
  console.log("tableList", tableList);

  const tableToolbarBeforeView = () =>
    showFilter && (
      <TrainingBatchFilters
        fields={trainingbatchFilterFields}
        setForm={setFilterForm}
        form={filterForm}
        onChange={onChangeFilter}
        onReset={onReset}
      />
    );

  return (
    <div>
      {selectedBatchId ? (
        <>
          <div className="addressSmlSec" style={{ paddinTop: "0", borderTop: "0" }}>
            <Row>
              <Col md={3} className="drilingView-bx">
                <h5>Training ID</h5>
                <p>{selectedBatch?.trainingId}</p>
              </Col>
              <Col md={3} className="drilingView-bx">
                <h5>Batch ID</h5>
                <p>{selectedBatch?.batchId}</p>
              </Col>
              <Col md={3} className="drilingView-bx">
                <h5>Date of commencement of training</h5>
                <p>{selectedBatch?.trainingDateView}</p>
              </Col>
              <Col md={3} className="drilingView-bx">
                <h5>End Date Of Training</h5>
                <p>{selectedBatch?.endDate}</p>
              </Col>
              <Col md={3} className="drilingView-bx">
                <h5> Number Of Days</h5>
                <p>{selectedBatch?.numberOfDays}</p>
              </Col>
              <Col md={3} className="drilingView-bx">
                <h5>Session</h5>
                <p>{selectedBatch?.session}</p>
              </Col>
              <Col md={3} className="drilingView-bx">
                <h5>Schedule</h5>
                <p>{selectedBatch?.schedule}</p>
              </Col>
              <Col md={3} className="drilingView-bx">
                <h5>Name of Centre</h5>
                <p>{selectedBatch?.centerName}</p>
              </Col>
              <Col md={3} className="drilingView-bx">
                <h5>Centre Code</h5>
                <p>{selectedBatch?.centerCode}</p>
              </Col>
              {/* <Col md={3} className="drilingView-bx">
                <h5>Area</h5>
                <p>{selectedBatch?.areaName}</p>
              </Col> */}
              <Col md={3} className="drilingView-bx">
                <h5>Training Category (Skill Area)</h5>
                <p>{selectedBatch?.trainingCategoryName}</p>
              </Col>
              <Col md={3} className="drilingView-bx">
                <h5>Training Category (Skill Subarea)</h5>
                <p>{selectedBatch?.trainingSubCategoryData?.name}</p>
              </Col>
              <Col md={3} className="drilingView-bx">
                <h5>Duration (Days)</h5>
                <p>{selectedBatch?.duration}</p>
              </Col>
            </Row>
          </div>
          <SearchBootstrapTable
            searchKey={"trainingBatchHistoryTM1DesktopSearch"}
            data={tableList}
            columns={sortableColumn}
            tableKey="trainingBatchHistoryTM1"
          />
        </>
      ) : (
        <div>
          <SearchBootstrapTable
            searchKey={"trainingBatchHistoryTM1DesktopSearch"}
            data={tableList.map((d, idx) => ({ ...d, sid: idx + 1 }))}
            columns={sortableColumn}
            tableKey="trainingBatchHistoryTM1"
            // CustomSearch={CustomSearch}
            tableBeforeSearch={tableToolbarBeforeView}
          />
        </div>
      )}
      {selectedBatchId && (
        <div className="mt-2 text-center">
          <Button onClick={resetBatch}>Back</Button>
        </div>
      )}
    </div>
  );
}

export default TrainingBatchHistoryTab;
